import React, {useCallback, useEffect, useState} from 'react';
import {PageHeader, PageWidget} from "../../components/contentComponents";
import {Icon} from "@iconify/react";
import {Button, Divider, Popconfirm, Select, Table, Space, Row, Col} from "antd";
import {useDispatch, useSelector} from "react-redux";
import TableWrapper from "../../components/antdWrappers/TableWrapper";
import {
    loadStrategies,
    loadTraderStrategySignals,
    updatePagination,
    updateSelectedStrategies,
    loadAssets,
    updateSelectedAssets, loadOrders
} from "./traderStrategySignalsSlice";
import moment from "moment/moment";
import SignalAssetEventDetails from "../strategies/SignalAssetEventDetails";
import {loadSignalAssetEvents} from "../strategies/signalsSlice";
import AssetEventOrders from "./AssetEventOrders";

const Option = Select.Option;


const TraderStrategySignalsPage = () => {

    const columns = [
        {
            title:
                <React.Fragment>
                    <div>Время</div>
                </React.Fragment>
            , render: (record) => {
                const {createdAt} = record;
                return (moment(createdAt).format('DD.MM.YYYY HH:mm:ss'));
            }
            , width: 250
        },
        {
            title:
                <React.Fragment>
                    <div>Стратегия</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {strategyCode} = signal;
                return (
                    <React.Fragment>
                        {strategyCode}
                    </React.Fragment>)
            }
            , width: 250
        },
        {
            title: 'Счет'
            , render: (record) => {
                const { asset = {}} = record;
                const name = asset?.name || 'Нет данных';
                return name;
            }
            , width: 250
        },
        {
            title:
                <React.Fragment>
                    <div>Тикер</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {security: { id, ticker }} = signal;
                return (
                    <React.Fragment>
                        {ticker}
                    </React.Fragment>)
            }
        },
        {
            title:
                <React.Fragment>
                    <div>Цена</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {price = undefined} = signal;
                return (
                    <React.Fragment>
                        {price}
                    </React.Fragment>)
            }
        },
        {
            title:
                <React.Fragment>
                    <div>Тип сигнала</div>
                </React.Fragment>
            , render: (text, record) => {
                const {signal = {}} = record;
                const {signalType = undefined} = signal;
                return (
                    <React.Fragment>
                        {signalType}
                    </React.Fragment>)
            }
        },
        {
            title:
                <React.Fragment>
                    <div>Тип события</div>
                </React.Fragment>
            , dataIndex: 'eventType'
        }
    ];

    const dispatch = useDispatch();

    const {
        signalEvents,
        loading,
        pagination,
        strategies,
        selectedStrategies,
        assets,
        selectedAssets,
        orders,
        loadingOrders
    } = useSelector(state => state.traderStrategySignals);

    useEffect(() => {
        dispatch(loadStrategies());
        dispatch(loadAssets());
    }, [dispatch]);

    useEffect(() => {
        dispatch(loadTraderStrategySignals({pagination, selectedStrategies, selectedAssets}));
    }, [dispatch, pagination.current, pagination.pageSize, selectedStrategies, selectedAssets]);

    return(
        <>
            <PageHeader caption='Сигналы стратегий' />
            <PageWidget >
                <Space style={{ width: '100%' }} direction="vertical">
                    <Row gutter={12} style={{ width: '50%' }}>
                        <Col span={12}>
                            <Select
                                mode="multiple"
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Выберите стратегию"
                                value={selectedStrategies}
                                onChange={(value) => {
                                    console.log(value);
                                    dispatch(updateSelectedStrategies(value));
                                }}
                            >
                                {strategies.map(strategy => {
                                    const op = <Option key={strategy.code} value={strategy.code}>{`${strategy.name}`}</Option>
                                    return op;
                                })}
                            </Select>
                        </Col>
                        <Col span={12}>
                            <Select
                                mode="multiple"
                                allowClear
                                showSearch
                                style={{ width: '100%' }}
                                placeholder="Выберите счет"
                                value={selectedAssets}
                                onChange={(value) => {
                                    console.log(value);
                                    dispatch(updateSelectedAssets(value));
                                }}
                            >
                                {assets.map(strategy => {
                                    const op = <Option key={strategy.id} value={strategy.id}>{`${strategy.name}`}</Option>
                                    return op;
                                })}
                            </Select>
                        </Col>
                    </Row>
                    <div>
                        <TableWrapper>
                            <Table
                                columns={columns}
                                rowKey='id'
                                dataSource={signalEvents}
                                loading={loading}
                                pagination={pagination}
                                size="small"
                                bordered
                                onChange={( pagination, tableFilters, sorter) => {
                                    const {field, order} = sorter;
                                    const sort = { field, order };
                                    dispatch(updatePagination(pagination));
                                }}
                                expandable={{
                                    expandedRowRender: (record) => <AssetEventOrders
                                        orders={orders[record.id]}
                                        loading={loadingOrders[record.id]}
                                    />,
                                    onExpand: (expanded, record) => {
                                        if (expanded && !orders[record.id]) {
                                            dispatch(loadOrders(record.id));
                                        }
                                    }
                                }}
                            />
                        </TableWrapper>
                    </div>
                </Space>
            </PageWidget>
        </>
    )
}

export default TraderStrategySignalsPage;
